export { fetchTypeahead } from 'next-flight-server-reference-proxy-loader?id=7f006174c904203cf568dd38daf1ec5024a84ac334&name=fetchTypeahead!'